import { render, staticRenderFns } from "./TextRange.vue?vue&type=template&id=321c0ca5&"
import script from "./TextRange.vue?vue&type=script&lang=js&"
export * from "./TextRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports